module.exports = __webpack_public_path__ + "img/restaurante-arabe.494e36ac.svg";